import { ObjectFieldTemplateProps } from '@rjsf/utils';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const isAdvanced = (
  uiSchema: ObjectFieldTemplateProps['uiSchema'],
  name: string,
): boolean => {
  const fieldUi = (uiSchema as Record<string, unknown> | undefined)?.[name] as
    Record<string, unknown> | undefined;
  const opts = fieldUi?.['ui:options'] as Record<string, unknown> | undefined;
  return Boolean(opts?.advanced);
};

export const CollapsibleSection = (props: ObjectFieldTemplateProps) => {
  const { properties, uiSchema } = props;
  const primary = properties.filter(p => !isAdvanced(uiSchema, p.name));
  const advanced = properties.filter(p => isAdvanced(uiSchema, p.name));

  const summary =
    (uiSchema?.['ui:advancedTitle'] as string) || 'Advanced settings';
  const help = uiSchema?.['ui:advancedDescription'] as string | undefined;

  return (
    <>
      {primary.map(p => (
        <div key={p.name}>{p.content}</div>
      ))}
      {advanced.length > 0 && (
        <Accordion
          variant="outlined"
          defaultExpanded={false}
          style={{ marginTop: 16 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div>
              <Typography variant="subtitle1">{summary}</Typography>
              {help && (
                <Typography variant="caption" color="textSecondary">
                  {help}
                </Typography>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ width: '100%' }}>
              {advanced.map(p => (
                <div key={p.name}>{p.content}</div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};
